@if (!readonly) {
    <mat-form-field class="flex" [ngClass]="{ 'cb-soft-required': softRequired && !required }">
        <mat-label>{{ getLabel() }}</mat-label>
        <mat-select
            [cbRequireSelectionValidator]="required"
            [required]="required"
            [disabled]="disabled"
            [ignoreDirty]="ignoreDirty"
            [name]="internalName"
            [(ngModel)]="value"
            [compareWith]="selectComparator.compareSelectOptions"
        >
            @for (opt of options; track opt) {
                <mat-option
                    [value]="
                        valueProp
                            ? valueProp === WHOLE_OPTION_VALUE_PROP
                                ? opt
                                : opt[valueProp]
                            : opt.id || 0
                    "
                >
                    <!-- 0 is used for "All" option. Required to show the selected option label when selecting "All" -->
                    {{ getDisplay(opt) }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
}
@if (readonly) {
    <div class="flex">
        <cb-display-value-new class="flex" [label]="label">
            {{ readonlyDisplayValue }}
        </cb-display-value-new>
    </div>
}
